<template>
  <div>
    <div class="marquee-wrap">
      <ul class="marquee-box" id="marquee-box">
        <!-- 循环3次为了无缝衔接， 给第一个设置Id 方便计算文字宽度 -->
        <li style="cursor: pointer;" class="marquee-list" v-for="item in list" v-html="item.title" :key="item.id" :id="item.id == 1 ? 'marquee' : 'marquee'" @click="handleOpen(item)"></li>
      </ul>
    </div>
  </div>
</template>
<script>
import { getNoticeList } from "@/api/common";
export default {
  props: {},
  data() {
    return {
      list: []
    };
  },
  mounted: function () {
    this.getNoticeFunction();
    // 延时滚动
    setTimeout(() => {
      this.runMarquee();
    }, 3000);
  },

  methods: {
    async getNoticeFunction() {
      const { code, data } = await getNoticeList();
      if (code == 200) {
        this.list = data.slice(0, 5);
      }
    },
    handleOpen(item) { 
      if (item.status === 1) {
        this.$emit("handleOpen", item)
        // addHits(item.id)
        // this.info = item;
        // this.showList = false;
      }
      if (item.status === 2) {
        window.open(item.brief)
      } 
    },
    runMarquee() {
      // 获取文字 计算后宽度
      var width = document.getElementById("marquee").getBoundingClientRect().width,
        marquee = document.getElementById("marquee-box"),
        disx = 0; // 位移距离
      //设置位移
      setInterval(() => {
        disx--; // disx-=1; 滚动步长
        if (-disx >= width * 3.5) {
          disx = 10; // 如果位移超过文字宽度，则回到起点  marquee-list的margin值
        }
        // marquee.style.transform = 'translateX(' + disx + 'px)'
        marquee.style.left = disx + "px";
      }, 30); //滚动速度
    }
  }
};
</script>
<style>
body,
div,
html,
img,
li,
ul {
  margin: 0;
  padding: 0;
  border: 0;
}
li {
  list-style: none;
}
.advert-top {
  position: relative;
  display: flex;
  width: 100%;
  height: 0.88rem;
  background: linear-gradient(
    270deg,
    rgba(80, 175, 255, 1) 0,
    rgba(13, 132, 248, 1) 48%,
    rgba(55, 159, 248, 1) 86%,
    rgba(81, 176, 255, 1) 100%
  );
  color: #fff;
  font-size: 0.26rem;
  align-items: center;
}
.ico-horn {
  display: flex;
  width: 0.88rem;
  height: 0.88rem;
  justify-content: center;
  align-items: center;
}
.ico-horn > img {
  width: 0.32rem;
  height: 0.32rem;
}
/* 以下代码与滚动相关 */
.marquee-wrap {
  position: relative;
  display: flex;
  overflow: hidden;
  width: 100%;
  height: 100%;
}
.marquee-box {
  position: absolute;
  top: 50%;
  display: flex;
  white-space: nowrap;
  transform: translateY(-50%);
}
.marquee-list {
  margin-right: 30px;
} /* 此处“px”方便回到起点 */
.marquee-list span {
  padding: 0 0.04rem;
  color: #ffe17b;
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/components/common/headTopNotice.vue